module.exports = __webpack_public_path__ + "images/bg3.42d361f.jpg";